// extracted by mini-css-extract-plugin
export default {"codeWrapper":"login-dialog_codeWrapper__Qb1cn"};